export default __webpack_public_path__ + "static/media/me.e1ea7b57.jpg";